export function isMobileLayout() {
  return window.matchMedia('(max-width: 600px)').matches;
}

export function allEmpty(...args) {
  return args.every((arg) => arg === '');
}
